import store from "../store/index"
import {
    mqttConfig
} from "../config/mqttConfig"

let client

export async function connect() {

    client = mqtt.connect(mqttConfig['data'].url, {
        username: mqttConfig['data'].username,
        password: mqttConfig['data'].password,
    });

    await new Promise((resolve, reject) => {
        client.on("connect", () => {
            // console.log("Mqtt connected ...");
            resolve()
        });
    })

    let temp = []

    // 每秒提交一次
    setInterval(() => {
        let list = [].concat(temp)
        temp = []
        store.dispatch("addMqttValList", list)
    }, 2000)

    client.on("message", (topic, message) => {
        // if (topic.includes('T2/2AA8/SwitchOn15/Switch_status_5')) {

        //     console.log(topic, message.toString());
        //     console.log(new Date());
        // }

        let keys = topic.split('/')
        let len = keys.length
        let devicesName = keys.slice(4, len - 1).join('/')
        let key = keys.slice(4).join('/')

        // console.log(key,message.toString())

        temp.push({
            key,
            val: message.toString()
        })
    });
}

export async function destroyConnection() {
    if (client) {
        try {
            client.end()
            client = null
            console.log('Successfully disconnected!')
        } catch (error) {
            console.log('Disconnect failed', error.toString())
        }
    }
}

function createNodeTopics(nodes) {
    let db = store.state.project.projectInfo.influxDbName
    return nodes.map(item => {
        if (store.state.project.projectInfo.projectId == 4) {
            return `VrMaker/${db}/+/PUBLISH/+/+/+/${item}`
        } else {
            return `VrMaker/${db}/+/PUBLISH/+/+/${item}`
        }
    })
}

export function subscribeByNodes(nodes) {
    client && client.subscribe(createNodeTopics(nodes));
}

export function unsubscribeByNodes(nodes) {
    client && client.unsubscribe(createNodeTopics(nodes));
}

export async function subscribebyLoopUrl(subLoopUrl) {
    if (Array.isArray(subLoopUrl)) {
        subLoopUrl.forEach(item => {
            client && client.subscribe(`VrMaker/${store.state.project.projectInfo.influxDbName}/+/PUBLISH/${item}/#`)
            // console.log('订阅：' + `VrMaker/${store.state.project.projectInfo.influxDbName}/+/PUBLISH/${item}/#`);
        })
    } else {
        client && client.subscribe(`VrMaker/${store.state.project.projectInfo.influxDbName}/+/PUBLISH/${subLoopUrl}/#`)
        // console.log('订阅：' + `VrMaker/${store.state.project.projectInfo.influxDbName}/+/PUBLISH/${subLoopUrl}/#`);
    }
}

export function unsubscribebyLoopUrl(subLoopUrl) {
    if (Array.isArray(subLoopUrl)) {
        subLoopUrl.forEach(item => {
            client && client.unsubscribe(`VrMaker/${store.state.project.projectInfo.influxDbName}/+/PUBLISH/${item}/#`)
        })
    } else {
        client && client.unsubscribe(`VrMaker/${store.state.project.projectInfo.influxDbName}/+/PUBLISH/${subLoopUrl}/#`)
    }
}